import SessionalDetailsAction from "@common/redux/actions/SessionalDetailsAction";
import LinkSessionAction from "@common/redux/actions/LinkSessionAction";

export const handleOptionChange = (option, gridData, rowIndex) => {
  const newGridData = gridData.map((row, index) => {
    if (index === rowIndex) {
      const newCellData = row.cellData.map((cell) => {
        if (cell.type === "control") {
          return { ...cell, data: option };
        }
        return cell;
      });
      return { ...row, cellData: newCellData };
    }
    return row;
  });

  return newGridData;
};

export const handleRowClickOptionChange = (gridData, clickedRow) => {
  const newGridData = gridData.map((row) => {
    if (row.sessionId === clickedRow.sessionId) {
      const newCellData = row.cellData.map((cell) => {
        if (cell.type === "control") {
          return {
            ...cell,
            data: {
              ...cell.data,
              defaultText: toggleSessionOption(cell.data.defaultText),
            },
          };
        }
        return cell;
      });
      return { ...row, cellData: newCellData };
    }
    return row;
  });

  return newGridData;
};

const toggleSessionOption = (currentValue) => {
  return currentValue.toLowerCase() === "false" ? "true" : "false";
};

export const handleSessionsOptionChange = (clickedRow, newGridData) => {
  SessionalDetailsAction.onOptionChange(newGridData);
  LinkSessionAction.toggleLinkSession(clickedRow);
};

export const handleSessionsRowClick = (clickedRow, newGridData) => {
  LinkSessionAction.toggleLinkSession(clickedRow);
  SessionalDetailsAction.onOptionChange(newGridData);
};

// Filter out the sessions where the checkbox is "true", for removal purpose
export const filterSelectedSessions = (data) => {
  const selectedSessions = data.filter((x) => {
    const selectedRow = x.cellData.find((x) => x.type === "control");
    if (selectedRow)
      return selectedRow.data.defaultText.toLowerCase() === "true";
  });
  return selectedSessions;
};

// When a user has come through the route of selecting a session via the compliance
// alerts tab, assign the relevant session automatically to the interaction via
// the sessionId
export const setSessionBySessionId = (sessionId, sessions) => {
  const selectedSession = sessions.find((x) => x.sessionId === sessionId);
  if (selectedSession) {
    LinkSessionAction.dispatch({ linkedSessionData: [selectedSession] });
  }
};
